export enum ChangePasswordStatus {
  success = 'success',
  fail = 'fail',
}
